package com.hyperether.goodjob.repository.remote.model

import kotlinx.serialization.Serializable

@Serializable
data class ConfirmationRequest(
    val hash: String,
)